import { useCallback } from 'react';
import { BasicItemMenuButton } from '../common';
import type { GroupMemberInvitation } from '@group/domain';
import { GroupMemberInvitationOperation } from '@group/domain/GroupMemberInvitation/GroupMemberInvitationOperation';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

type Props = {
  invitation: GroupMemberInvitation;
};

export const DeactivateMenuButton: React.FC<Props> = ({ invitation }: Props) => {
  const { t } = useTranslation();
  const handleDeactivate = useCallback(async () => {
    try {
      await GroupMemberInvitationOperation.deactivate(invitation);
      toast.success(t('group.invitations.deactivate.success'));
    } catch (e) {
      toast.error(t('group.invitations.deactivate.error'));
      console.error('Failed to deactivate of invitation', invitation, e);
    }
  }, [invitation, t]);

  return <BasicItemMenuButton menuTitle={t('group.invitations.deactivate.menuTitle')} onClickMenu={handleDeactivate} />;
};
